// What the calls screens read again when a call changes elsewhere: the team
// events of calls (started, someone in or out, ended) drop the workspace's
// list of calls. Payloads carry ids only.
import type { TeamRealtimeHandler, TeamRealtimeHandlers } from "../workspace";
import { voicesKey } from "./queries";

const dropList: TeamRealtimeHandler = (_payload, { qc, event, slugOf }) => {
  const slug = slugOf(event.workspaceId);
  if (slug !== null) void qc.invalidateQueries({ queryKey: voicesKey(slug) });
};

export const voiceTeamHandlers: TeamRealtimeHandlers = {
  "voice_room.created": dropList,
  "voice_room.changed": dropList,
  "voice_room.ended": dropList,
};
